<template>
  <div class="container-feedback">
    <MpNavbar active="words" />
    <MpTitle title="快捷词库管理" intro="管理、添加、删除快捷词库" />
    <div class="content-table" v-show="tableData">
      <!-- height="300" :loading="loading" -->
      <vxe-toolbar>
        <template #buttons>
          <vxe-button @click="reflash">刷新</vxe-button>
          <!-- <vxe-button @click="exportDataEvent">导出.xlsx</vxe-button> -->
          <vxe-button @click="showAddDialog">添加快捷词</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table round border highlight-hover-row resizable ref="xTable" :data="tableData">
        <vxe-table-column type="seq" width="60"></vxe-table-column>
        <vxe-table-column field="text" title="快捷词"></vxe-table-column>
        <!-- <vxe-table-column field="updateTime" :formatter="formatTime" title="添加时间"></vxe-table-column> -->
        <vxe-table-column title="操作" width="100">
          <template #default="{ row, rowIndex }">
            <van-button color="#489D80" size="small" round @click="delWord(row)">删除词汇</van-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager background size="small" :loading="loading" :current-page="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.totalResult" :page-sizes="[10, 50, 200, 1000]" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" @page-change="handlePageChange">
      </vxe-pager>
    </div>
    <van-dialog v-model="showAdd" title="添加快捷词" show-cancel-button confirm-button-text="保存" confirm-button-color="#489D80" @confirm="saveNewWord()">
      <div class="addWordsBox">
        <textarea type="text" v-model="newWord" class="addWordsInput" placeholder="请输入（一行输入一个词汇）" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import MpNavbar from '../../components/mp/navbar'
  import MpTitle from '../../components/mp/title'
  import { apiGetWords, apiAddWords, apiDelWords } from '../../request/api'
  import { Dialog, Toast } from 'vant';
  // Vue.use(Toast);

  export default {
    components: {
      MpNavbar,
      MpTitle,
      [Dialog.Component.name]: Dialog.Component,
    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
      return {
        loading: false,
        tableData: null,
        newWord: null,
        tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: null
        },
        showAdd: false,
      }
    },
    filters: {},
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.getWords()
      },
      showAddDialog() {
        console.log("showAdd")
        this.showAdd = true
      },
      saveNewWord() {
        console.log("saveNewWord")
        let self = this
        if (this.newWord == null || this.newWord.length == 0) {
          Toast('未输入文字');
          return
        }
        let wordsArray = this.newWord.split('\n')
        console.log(wordsArray)
        apiAddWords({
          word: wordsArray
        }).then(res => {
          console.log(res.data)
          Toast.success('保存成功');
          self.reflash()
          self.newWord = null
          self.loading = false
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      delWord(row) {
        let self = this
        console.log(row)
        Dialog.confirm({
            title: '确定删除「'+row.text+'」',
            message: '删除操作无法撤销',
          })
          .then(() => {
            // on confirm
            apiDelWords({
              id: row.id
            }).then(res => {
              console.log(res.data)
              Toast.success('删除成功');
              self.reflash()
              self.loading = false
            }).catch(err => {
              console.log(err)
              self.loading = false
            })
          })
          .catch(() => {
            // on cancel
            console.log("取消")
          });

      },
      reflash() {
        this.tablePage = {
          currentPage: 1,
          pageSize: 10,
          totalResult: null
        }
        this.tableData = null
        this.getWords()
      },
      getWords() {
        let self = this
        self.loading = true
        apiGetWords({
          page: self.tablePage.currentPage,
          size: self.tablePage.pageSize,
        }).then(res => {
          console.log(res.data)
          self.tableData = res.data.items
          self.tablePage.totalResult = res.data.count
          self.loading = false
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      handlePageChange({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.getWords()
      },
      formatTime({ cellValue, row, column }) {
        let time = new Date(cellValue)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) { month = '0' + month }
        if (date < 10) { date = '0' + date }
        if (hours < 10) { hours = '0' + hours }
        if (minute < 10) { minute = '0' + minute }
        if (second < 10) { second = '0' + second }
        return year + '.' + month + '.' + date + ' ' + hours + ':' + minute
      },
      exportDataEvent() {
        this.$refs.xTable.exportData({
          filename: '快捷词库',
          sheetName: 'Sheet1',
          type: 'xlsx'
        })
      },
      go(where) {
        this.$router.push('/' + where)
      },
    }
  }
</script>

<style scoped>
  .container-feedback {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
    padding-left: 110px;
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
  }

  .addWordsBox {
    width: 100%;
    padding: 30px 20px 40px;
  }

  .addWordsInput {
    width: 100%;
    height: 200px;
    border: 1px solid #efefef;
    background-color: #efefef;
    overflow: hidden;
    padding: 10px;
    border-radius: 5px;
    color: #333;
    resize: none;
  }
</style>